export enum Api {
  One_Portal
}
